/* istanbul ignore file */
/**
 * Progress Bar component theme configuration.
 */

export const progressbarComponentConfig = {
  progressbar: {
    root: {
      borderRadius: '{border.radius.sm}',
      height: '8px',
    },
    value: {
      background: '{primary.color}',
    },
    label: {
      color: '{surface.800}',
      fontSize: '14px',
      fontWeight: '400',
    },
    colorScheme: {
      light: {
        root: {
          background: '{surface.200}',
        },
      },
      dark: {
        root: {
          background: '{surface.600}',
        },
      },
    },
  },
};
